interface SvgProps {
    color?: string;
    width?: string;
    height?: string;
  }
  
  const DownArrow = ({
    color = "black",
    width = "16",
    height = "20",
  }: SvgProps) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.43745 10.4762L7.62339 16.4527C7.67027 16.5068 7.72822 16.5502 7.79333 16.5799C7.85843 16.6096 7.92917 16.625 8.00074 16.625C8.07231 16.625 8.14304 16.6096 8.20814 16.5799C8.27325 16.5502 8.3312 16.5068 8.37808 16.4527L13.5625 10.4762C13.5781 10.4581 13.5883 10.436 13.5917 10.4124C13.5952 10.3888 13.5917 10.3646 13.5819 10.3429C13.572 10.3212 13.5561 10.3027 13.536 10.2898C13.5159 10.2768 13.4926 10.2699 13.4687 10.2699H12.2031C12.1312 10.2699 12.0625 10.3012 12.014 10.3558L8.5937 14.298V5.49959C8.5937 5.43084 8.53745 5.37459 8.4687 5.37459H7.5312C7.46245 5.37459 7.4062 5.43084 7.4062 5.49959V14.298L3.98589 10.3558C3.93902 10.3012 3.87027 10.2699 3.79683 10.2699H2.5312C2.42495 10.2699 2.36714 10.3949 2.43745 10.4762Z"
          fill={color}
        />
      </svg>
    );
  };
  
  export default DownArrow;
  